import WarningMessage from 'components/elements/items/WarningMessage'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import { LocationConfirmProps } from 'constants/map'
import { WARNING } from 'constants/messages'
import React from 'react'
import styled from 'styled-components'
import { isSaficDomain } from 'utils/domain'

import MapConfirmContent from './MapConfirmContent'

/**
 * 運び先確認用コンテンツ
 */
const DestinationConfirmContent: React.FC<DestinationConfirmContentProps> = (
  props
) => {
  return (
    <React.Fragment>
      {props.mapProps ? (
        <React.Fragment>
          <MapConfirmContent {...props.mapProps} boldLocationText />
          {isSaficDomain() && (
            <WarningMessage message={WARNING.WRECKER} marginSideNone />
          )}
        </React.Fragment>
      ) : (
        <ConfirmArea>
          <li>
            {props.crossPrefectures === undefined
              ? `${CLIENT_SETTINGS.options.destinationType.introduction}`
              : `なし(都道府県を越える希望：
            ${props.crossPrefectures ? 'あり' : 'なし'})`}
          </li>
        </ConfirmArea>
      )}
    </React.Fragment>
  )
}

export type DestinationConfirmContentProps = {
  mapProps?: LocationConfirmProps & {
    component: React.ReactNode
  }
  crossPrefectures?: boolean
}

const ConfirmArea = styled.ul`
  padding-left: 34px;
`

export default React.memo<DestinationConfirmContentProps>(
  DestinationConfirmContent
)
